// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventPresentmentDigitalCredentialsOpenID4VP
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.eventlogger.EventPresentmentData
import org.multipaz.eventlogger.toDataItem
import org.multipaz.eventlogger.fromDataItem

fun EventPresentmentDigitalCredentialsOpenID4VP.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "-5CMDcHhTaneQ_iRfcjNloFs4lda2Wk4gUt8K208wpA")
val EventPresentmentDigitalCredentialsOpenID4VP_cborSchemaId = ByteString(-5, -112, -116, 13, -63, -31, 77, -87, -34, 67, -8, -111, 125, -56, -51, -106, -127, 108, -30, 87, 90, -39, 105, 56, -127, 75, 124, 43, 109, 60, -62, -112)

fun EventPresentmentDigitalCredentialsOpenID4VP.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "PresentmentDigitalCredentialsOpenID4VP")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentData", this.presentmentData.toDataItem())
    val appId = this.appId
    if (appId != null) {
        builder.put("appId", Tstr(appId))
    }
    builder.put("origin", Tstr(this.origin))
    builder.put("protocol", Tstr(this.protocol))
    builder.put("requestJson", Tstr(this.requestJson))
    builder.put("responseJson", Tstr(this.responseJson))
    builder.put("vpToken", Tstr(this.vpToken))
    val state = this.state
    if (state != null) {
        builder.put("state", Tstr(state))
    }
    return builder.end().build()
}

fun EventPresentmentDigitalCredentialsOpenID4VP_fromDataItem(dataItem: DataItem): EventPresentmentDigitalCredentialsOpenID4VP {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentData = EventPresentmentData.fromDataItem(dataItem["presentmentData"])
    val appId0 = if (dataItem.hasKey("appId")) {
        dataItem["appId"].asTstr
    } else {
        null
    }
    val origin = dataItem["origin"].asTstr
    val protocol = dataItem["protocol"].asTstr
    val requestJson = dataItem["requestJson"].asTstr
    val responseJson = dataItem["responseJson"].asTstr
    val vpToken = dataItem["vpToken"].asTstr
    val state0 = if (dataItem.hasKey("state")) {
        dataItem["state"].asTstr
    } else {
        null
    }
    return EventPresentmentDigitalCredentialsOpenID4VP(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentData = presentmentData,
        appId = appId0,
        origin = origin,
        protocol = protocol,
        requestJson = requestJson,
        responseJson = responseJson,
        vpToken = vpToken,
        state = state0,
    )
}
